module.exports = __webpack_public_path__ + "9c0cf79af5f8561dd2b3943292e6e8c1.png";